import { useState } from "react";
import { Search } from "lucide-react";
import { useSC, Pill, SCEN_TONE, Pager, Table, Td, fmtDate, Loading } from "./parts";

const SCENS = [
  ["", "All plan statuses"], ["active", "Diet plan active"], ["delivered", "Plan assigned & delivered"], ["following", "Following existing plan"],
  ["due_revision", "Due for revision"], ["awaiting_approval", "Awaiting dietitian approval"], ["pending_delivery", "Pending delivery"],
  ["awaiting_consult", "Waiting for consultation"], ["renewing", "Renewing subscription"], ["completed", "Subscription completed"],
  ["discontinued", "Inactive / discontinued"], ["onboarding", "Awaiting onboarding"],
];

export function ClientsTable({ dietitian = "", template = "", initialScenario = "", onOpenClient, testid = "sc-clients" }) {
  const [q, setQ] = useState("");
  const [scenario, setScenario] = useState(initialScenario);
  const [page, setPage] = useState(1);
  const qs = new URLSearchParams({ q, scenario, dietitian, template, page }).toString();
  const { data, loading } = useSC(`/clients?${qs}`);
  return (
    <div data-testid={testid}>
      <div className="flex gap-2 flex-wrap mb-3">
        <div className="relative flex-1 min-w-[180px]">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 opacity-50" />
          <input data-testid={`${testid}-search`} value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} placeholder="Search name or client ID" className="w-full pl-8 pr-3 py-2 rounded-full border text-sm bg-transparent" style={{ borderColor: "var(--border-strong)" }} />
        </div>
        <select data-testid={`${testid}-scenario`} value={scenario} onChange={(e) => { setScenario(e.target.value); setPage(1); }} className="px-3 py-2 rounded-full border text-sm bg-transparent" style={{ borderColor: "var(--border-strong)" }}>
          {SCENS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </div>
      {loading && !data ? <Loading /> : (
        <>
          <Table head={["Client ID", "Name", "Age", "City", "Dietitian", "Package", "Joined", "Plan status", "Next follow-up"]}>
            {data?.items.map((c) => (
              <tr key={c.cid} data-testid={`sc-client-row-${c.cid}`} onClick={() => onOpenClient(c.cid)} className="cursor-pointer hover:bg-[var(--bg)] transition-colors">
                <Td className="font-mono text-xs">{c.cid}</Td>
                <Td className="font-semibold">{c.name}</Td>
                <Td>{c.age}</Td>
                <Td>{c.city}</Td>
                <Td>{c.dietitian}</Td>
                <Td>{c.package}</Td>
                <Td>{fmtDate(c.joined)}</Td>
                <Td><Pill tone={SCEN_TONE[c.scenario]}>{c.plan_status}</Pill></Td>
                <Td>{fmtDate(c.next_consult)}</Td>
              </tr>
            ))}
          </Table>
          <Pager data={data} page={page} setPage={setPage} testid={testid} />
        </>
      )}
    </div>
  );
}
